import { useContext } from "react";
import LightBoxContext from "../context/LightBoxContext";

const useLightBoxContext = () => {
    const lightBoxContext = useContext(LightBoxContext);
    if (!lightBoxContext) {
        throw new Error('LightBoxContext has to be used within <LightBoxContext.Provider>');
    } else {
        return lightBoxContext
    }
}

export default useLightBoxContext;